import React, { useState, useRef, useEffect } from "react";
import { StoreData } from "../../pages/Home/utils";

interface LanguageSwitcherProps {
  bussinessData: StoreData;
  languages: any[];
  currentLanguage: "ar" | "en" | "kr";
  onLanguageChange: (languageCode: string) => void;
  className?: string;
}

const LanguageDropdown: React.FC<LanguageSwitcherProps> = ({
  bussinessData,
  languages,
  currentLanguage,
  onLanguageChange,
  className = "",
}) => {
  // 🇦🇪
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [languagesObject, setLanguageObject] = useState({
    en: { name: "English", flag: "🇬🇧" },
    ar: { name: "العربية", flag: "🇮🇶" },
    kur: { name: "كوردى", flag: "🇹🇯" },
  });
  const currentLang =
    languages.find((lang) => lang.code === currentLanguage) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);
  useEffect(() => {
    if (bussinessData && bussinessData.country_short_name === "ae") {
      setLanguageObject({
        ...languagesObject,
        ar: { name: "العربية", flag: "🇦🇪" },
      });
    }
  }, [bussinessData]);
  const handleLanguageSelect = (languageCode: string) => {
    onLanguageChange(languageCode);
    setIsOpen(false);
  };

  return (
    <div className={`language-switcher ${className}`} ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lang-button"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-label="Select language"
      >
        <span className="current-flag">
          {/* @ts-ignore */}
          {languagesObject[currentLanguage].flag}
        </span>
        <span className="current-code">
          {/* @ts-ignore */}
          {currentLanguage.toUpperCase()}
        </span>
        <span className={`chevron ${isOpen ? "open" : ""}`}>▼</span>
      </button>

      {isOpen && (
        <div className="lang-dropdown">
          {languages.map((language) => (
            <button
              key={language}
              onClick={() => handleLanguageSelect(language)}
              className={`lang-option ${
                language === currentLanguage ? "active" : ""
              }`}
            >
              <span className="option-flag">
                {/* @ts-ignore */}

                {languagesObject[language].flag}
              </span>
              <div className="lang-info">
                <span className="lang-name">
                  {/* @ts-ignore */}
                  {languagesObject[language].name}
                </span>
                <span className="lang-code">{language.toUpperCase()}</span>
              </div>
              {language === currentLanguage && (
                <div className="active-indicator"></div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageDropdown;
